import { createSelector } from '@ngrx/store';

import { HotelResultsModuleState } from '@hotels/hotel-results/store/state/hotel-results-module.state';
import { HotelFiltersPayloadState } from '@hotels/hotel-results/store/reducers/hotel-filters-payload.reducer';
import { hotelResultsRootSelector } from '@hotels/hotel-results/store/selectors/hotel-results-root.selector';

export const getHotelFiltersPayloadState = createSelector(
  hotelResultsRootSelector,
  (state: HotelResultsModuleState) => state.hotelFiltersPayload
);

export const hotelFiltersPayload = createSelector(getHotelFiltersPayloadState, (state: HotelFiltersPayloadState) => state);
